module.exports = __webpack_public_path__ + "assets/img/11-2.6d35f01d.png";